import { createFileRoute } from '@tanstack/react-router';

import { AdminAccountView } from '@/views/admin/account-view.tsx';

export const Route = createFileRoute('/admin/account')({
  component: AdminAccountView,
});
